import { Injectable } from '@angular/core';


@Injectable()
export class SharedConstants {
  static networkErrorMessage = 'Sorry, it seems you are offline. Please check your internet connectivity.';
  static stringPaths = {
    pathPart1: 'U2FsdGVkX1/Y05VPmn4MyWM9L4gsEWyC/eBF/InQuuk=',
    pathPart2: 'U2FsdGVkX18WlryiB+iqhPf/glPOXbt2hQmVEMeimuQ=',
    addyPart1: 'U2FsdGVkX1+EHLMWRNbESFOtq5R6XLAJnijbj6vRWc1/JNBfZAXTdcOpFbaD5q0h',
    addyPart2: 'U2FsdGVkX1+o2cmFLSHiIRWURE9gXbhcIXSTxCp28qR0f8a0e91659yxx88NZCky',
    testString: 'imSmart-web',
  };
}



// WEBPACK FOOTER //
// ./src/services/shared/shared-constants.ts